export default __webpack_public_path__ + "static/media/rtl.5aa97608.svg";